import type { Option } from 'shared/ui/Select';

import { getJanFirstLastYear, getJanFirstThisYear, getLastNMonths, getLastNWeeks } from '../utils';

export function getDateOptions(): Option[] {
  return [
    {
      id: getLastNWeeks(2),
      text: 'Last 2 weeks',
    },
    {
      id: getLastNMonths(1),
      text: 'Last month',
    },
    {
      id: getLastNMonths(2),
      text: 'Last 2 months',
    },
    {
      id: getLastNMonths(3),
      text: 'Last 3 months',
    },
    {
      id: getLastNMonths(6),
      text: 'Last 6 months',
    },
    {
      id: getJanFirstThisYear(),
      text: 'This year',
    },
    {
      id: getJanFirstLastYear(),
      text: 'Last year',
    },
  ];
}
